(function () {
  const BACKEND = 'https://invernadas-copy-production.up.railway.app';
  const DEFAULT_LOCATION = '942178329'; // Salvador
  const SOLD_OUT_TEXT = 'Agotado';

  async function getLocationId() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      return (cart.attributes && cart.attributes['_cds_locationId']) || DEFAULT_LOCATION;
    } catch (e) {
      return DEFAULT_LOCATION;
    }
  }

  function getButton(card) {
    return card.querySelector('.quick-add__submit');
  }

  function getButtonSpan(btn) {
    return btn.querySelector('span:not(.sold-out-message):not(.loading__spinner):not(.icon-wrap)');
  }

  function markSoldOut(card) {
    const btn = getButton(card);
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('data-cds-sold-out', 'true');
    const span = getButtonSpan(btn);
    if (span) {
      btn.setAttribute('data-cds-original-text', span.textContent.trim());
      span.textContent = SOLD_OUT_TEXT;
    }
    const input = card.querySelector('input[name="id"].product-variant-id');
    if (input) input.disabled = true;
  }

  function markAvailable(card) {
    const btn = getButton(card);
    if (!btn) return;
    if (btn.getAttribute('data-cds-sold-out') !== 'true') return;
    btn.disabled = false;
    btn.removeAttribute('data-cds-sold-out');
    const span = getButtonSpan(btn);
    if (span) {
      const original = btn.getAttribute('data-cds-original-text');
      if (original) span.textContent = original;
      btn.removeAttribute('data-cds-original-text');
    }
    const input = card.querySelector('input[name="id"].product-variant-id');
    if (input) input.disabled = false;
  }

  async function checkCarouselStock() {
    const carousels = document.querySelectorAll('.cds-top-products');
    if (!carousels.length) return;

    const locationId = await getLocationId();
    const cards = [...document.querySelectorAll('.cds-top-products .product-card-wrapper[data-cds-product-id]')];
    if (!cards.length) return;

    const productIds = [...new Set(cards.map(c => c.dataset.cdsProductId).filter(Boolean))];
    if (!productIds.length) return;

    try {
      const data = await fetch(
        BACKEND + '/stock/levels/bulk?locationId=' + locationId + '&productIds=' + productIds.join(',')
      ).then(r => r.json());

      const stockMap = {};
      (data.products || []).forEach(p => { stockMap[String(p.productId)] = p.available; });

      cards.forEach(card => {
        const pid = String(card.dataset.cdsProductId);
        const stock = stockMap[pid] !== undefined ? stockMap[pid] : null;
        if (stock === null) return;

        if (stock === 0) {
          markSoldOut(card);
        } else {
          markAvailable(card);
        }
      });
    } catch (e) {
      console.error('[CDS] Error stock carrusel:', e);
    }
  }

  // Polling para detectar cambio de ubicación
  let lastLocation = null;
  let timer = null;

  async function poll() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const locationId = await getLocationId();
      if (locationId !== lastLocation) {
        lastLocation = locationId;
        checkCarouselStock();
      }
      poll();
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { checkCarouselStock(); poll(); });
  } else {
    checkCarouselStock();
    poll();
  }
})();
